import React, { createContext, useContext } from "react";
import { type NetworkStatus, useNetworkStatus } from "@/hooks/useNetworkStatus";

const NetworkStatusContext = createContext<NetworkStatus | undefined>(undefined);

export const useNetworkStatusContext = (): NetworkStatus => {
  const ctx = useContext(NetworkStatusContext);
  if (ctx === undefined) {
    throw new Error(
      "useNetworkStatusContext must be used within a NetworkStatusProvider",
    );
  }
  return ctx;
};

export const NetworkStatusProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const status = useNetworkStatus();
  return (
    <NetworkStatusContext.Provider value={status}>
      {children}
    </NetworkStatusContext.Provider>
  );
};
